/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { ModalTitle } from '@atlaskit/modal-dialog';
import { token } from '@atlaskit/tokens';

import Loading from 'src/components/loading';
import { CodeContainer } from 'src/styles';

export const DialogTitle = styled(ModalTitle)({
  justifyContent: 'space-between',
  width: '100%',
});

export const DialogTitleIcon = styled.span({
  marginRight: token('space.100'),
  flex: '0 0 auto',
});

export const DialogTitleText = styled.div({
  flex: '1 1 auto',
  minWidth: 0,
});

export const DiffWrapper = styled.div({
  border: `1px solid ${token('color.border')}`,
});

export const ModalLoading = styled(Loading)({
  height: '100%',
});

export const ScmCommandCodeContainer = styled(CodeContainer)({
  maxWidth: '540px',
});

export const FilePath = styled.h2({
  font: 'inherit',
  color: 'inherit',
  fontWeight: 'inherit',
  margin: 0,
  padding: 0,
  wordBreak: 'break-word',
  cursor: 'auto',
  display: 'flex',
  flexWrap: 'wrap',
});

export const DiffStatusIconWrapper = styled.span({
  padding: '4px',
});

export const FilePathWrapper = styled.span({
  marginTop: '3px',
  display: 'flex',
  flexWrap: 'wrap',
  font: token('font.heading.medium'),
});
